import { COLORS } from '@/theme';
import styled from 'styled-components';

export const StyledBadge = styled.div<{ $isActive?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0 0.75rem;
  height: 1.5rem;
  border-radius: 1.6rem;
  background: ${({ $isActive }) => ($isActive ? COLORS.GREEN : COLORS.NORMAL_GRAY)};
  color: ${COLORS.WHITE};
`;

export const StyledWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
  height: 100%;

  .partners-table .ant-table-thead > tr > th:nth-child(1),
  .partners-table .ant-table-tbody > tr > td:nth-child(1) {
    width: 15rem;
  }

  .partners-table .ant-table-thead > tr > th:nth-child(2),
  .partners-table .ant-table-tbody > tr > td:nth-child(2) {
    width: 10rem;
  }

  .partners-table .ant-table-thead > tr > th:nth-child(3),
  .partners-table .ant-table-tbody > tr > td:nth-child(3) {
    width: 10rem;
  }

  .partners-table .ant-table-thead > tr > th:nth-child(4),
  .partners-table .ant-table-tbody > tr > td:nth-child(4) {
    width: 10rem;
  }

  .partners-table .ant-table-thead > tr > th:nth-child(6) .ant-select,
  .partners-table .ant-table-thead > tr > th:nth-child(6) .ant-select-selector {
    width: 10rem;
  }

  .partners-table .ant-table-thead > tr > th:nth-child(7) .ant-select,
  .partners-table .ant-table-thead > tr > th:nth-child(7) .ant-select-selector {
    width: 10rem;
  }
`;
